module.exports = __webpack_public_path__ + "assets/img/shuffle.0200a4d7.svg";